import React from 'react';
import { Label } from 'reactstrap';
import { Badge, Card, CircleButton, Icon, LinkText, Typography } from "../../index";
import './qab_button.scss';

export const QABButton = ({
    className,
    count,
    disabled = false,
    icon,
    iconSize = "medium",
    isMobile = false,
    labelPosition = "right",
    onClick,
    showBadge,
    showLabel = true,
    size = "small",
    target,
    to,
    title = "",
    variant = "default"
}) => {

    const isCard = ((variant === "default" && !isMobile) || variant === "card");
    const Element = isCard ? Card : LinkText;

    const qabButtonClasses = [
        `mybswh-qab-button`,
        `mybswh-qab-button--${variant}`,
        `${!isCard ? 'mybswh-qab-button-label--' + labelPosition : 'mybswh-qab-button-label--' + labelPosition }`,
        `${className ? className : ''}`
    ].join(' ');
  
    return (
        <Element 
            aria-label={title}
            className={qabButtonClasses}
            disabled={disabled}
            to={{ pathname: to }}
            target={target}
            onClick={onClick}
            decorator={Element === LinkText ? "none" : ""}
            display={Element === LinkText ? "inline-block" : "" }
        >
            <div className="mybswh-qab-button__content">
                <Badge
                    count={count}
                    show={showBadge}
                    disabled={disabled}
                >
                    {isCard
                        ? <Icon name={icon} size={iconSize} disabled={disabled} />
                        : <CircleButton icon={icon} size={size} disabled={disabled} as={'div'} />
                    }
                </Badge>
                {showLabel && 
                    <div className="mybswh-qab-button__label">
                        {isCard
                            ? <Typography
                                color={disabled ? "$color-secondary-a4" : ""}
                                tag="div"
                                textAlign="center"
                                type="heading-01"
                                responsive
                            >
                                {title}
                            </Typography>
                            : <Typography
                                bold={labelPosition === 'bottom' ? true : false}
                                color={disabled ? "$color-secondary-a4" : "$color-primary-a2"}
                                tag="div"
                                textAlign="center"
                                type={labelPosition === 'bottom' ? "cta-02" : "body-01"}
                            >
                                {title}
                            </Typography>
                        }

                    </div>
                }
            </div>
        </Element>
    )
}